import {gql} from '@apollo/client';

/**
 * 批量作废「待DSP提交」罚单，对应 api-server `PartnerControlAppealReviewMutation.voidAppealTickets`。
 * 非该状态或已作废的 ID 由后端跳过，计入 skippedCount。
 */
export const VOID_APPEAL_TICKETS = gql`
    mutation VoidAppealTickets($ids: [Long!]!) {
        voidAppealTickets(ids: $ids) {
            voidedCount
            skippedCount
        }
    }
`;

export interface VoidAppealTicketsResponse {
    voidAppealTickets: {
        voidedCount: number;
        skippedCount: number;
    };
}
